/**
 * @generated SignedSource<<5899e16dfa5a6ea0365c4d7f731ee52f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProfilePageQuery$variables = Record<PropertyKey, never>;
export type ProfilePageQuery$data = {
  readonly followedTopics: {
    readonly totalCount: number | null | undefined;
  };
  readonly likedEpisodes: {
    readonly totalCount: number | null | undefined;
  };
  readonly viewer: {
    readonly email: string;
    readonly id: string;
    readonly isAdmin: boolean;
    readonly lastLoginAt: any | null | undefined;
    readonly role: string;
    readonly userId: string;
  } | null | undefined;
};
export type ProfilePageQuery = {
  response: ProfilePageQuery$data;
  variables: ProfilePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ViewerWithFeatures",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAdmin",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastLoginAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v0/*: any*/),
    "concreteType": "TopicConnection",
    "kind": "LinkedField",
    "name": "followedTopics",
    "plural": false,
    "selections": (v1/*: any*/),
    "storageKey": "followedTopics(first:1)"
  },
  {
    "alias": null,
    "args": (v0/*: any*/),
    "concreteType": "EpisodeConnection",
    "kind": "LinkedField",
    "name": "likedEpisodes",
    "plural": false,
    "selections": (v1/*: any*/),
    "storageKey": "likedEpisodes(first:1)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfilePageQuery",
    "selections": (v2/*: any*/),
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfilePageQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "acb3570cfbd17b70219cd0c1d0098464",
    "id": null,
    "metadata": {},
    "name": "ProfilePageQuery",
    "operationKind": "query",
    "text": "query ProfilePageQuery {\n  viewer {\n    id\n    userId\n    email\n    role\n    isAdmin\n    lastLoginAt\n  }\n  followedTopics(first: 1) {\n    totalCount\n  }\n  likedEpisodes(first: 1) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "79fa0e069f45a373b1fe47462d9ebb81";

export default node;
